// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2TF4c","title":"Images45_title__2oblV","images":"Images45_images__tTEMm"};